import { gql } from "@apollo/client"
import { usePaginatedQuery } from "~/hooks/usePaginatedQuery"
import { PayrollCycle } from "@oysterhr/schema"

const ITEMS_PER_PAGE = 10

export const PAYROLL_CYCLES_QUERY = gql`
  query PayrollCycles($employerOfRecordId: ID!, $page: Int, $perPage: Int) {
    payrollCycles(employerOfRecordId: $employerOfRecordId, page: $page, perPage: $perPage) {
      collection {
        id
        cutOffDate
        startDate
        endDate
        month
        year
        teamMembersCount
        state
        cycleNumber
        frequency
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`

export const usePayrollCycles = (employerOfRecordId: string) =>
  usePaginatedQuery<PayrollCycle>(PAYROLL_CYCLES_QUERY, {
    perPage: ITEMS_PER_PAGE,
    variables: { employerOfRecordId },
    fetchPolicy: "cache-and-network",
    onPath: "payrollCycles",
  })
